import './Theme.Feedback.Default.scss';
export default 'ThemeFeedbackDefault';
